<div [class]="styleClass" [ngClass]="'p-accordion p-component'" [ngStyle]="style">
  <ng-content />
</div>
